import { useMemo } from "react";
import { getCurrencySymbol } from "../utilities/CurrencySwitch";

const DEFAULT_SYMBOL = "€";

/**
 * Hook para lidar com códigos de moeda vindos do backend (BRL, USD, EUR, etc.)
 * e expor o símbolo para exibição (R$, $, €, etc.).
 *
 * @param {string} [currencyCode] - Código da moeda vindo da API (ex: data.walletInfo?.currency)
 * @returns {{ currencySymbol: string, currencyCode: string, getSymbol: (code: string) => string }}
 */
function useCurrency(currencyCode) {
  return useMemo(() => {
    const code = currencyCode?.trim() || "";
    const symbol = code ? getCurrencySymbol(code) : DEFAULT_SYMBOL;

    return {
      currencySymbol: symbol,
      currencyCode: code || "EUR",
      getSymbol: getCurrencySymbol,
    };
  }, [currencyCode]);
}

export default useCurrency;
